export const poStatus: {
  [key: number]: string
} = {
  1: "Pending",
  2: "Part Delivered",
  3: "Full Delivered",
  4: "Close by Admin"
}